var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillingAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 86,
    viewBox: "0 0 128 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_4439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H116C122.627 0 128 5.37258 128 12V74C128 80.6274 122.627 86 116 86H12C5.37258 86 0 80.6274 0 74V12Z",
    fill: "#1D71B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2165 69.9324V41.3595L128.071 41.4062V49.2987L122.192 55.5785L128.071 61.9188V69.9774H118.686L113.699 64.4747L108.747 69.9999L77.2165 69.9324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6133 66.7985V44.5036H99.5184V49.6395H86.7356V53.1264H99.2138V58.1775H86.7356V61.602H99.5184V66.7985H80.6133Z",
    fill: "#1D71B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4249 66.7984L109.884 55.6388L99.4249 44.5052H107.52L113.912 51.5706L120.322 44.5052H128.071V44.68L117.833 55.6388L128.071 66.4835V66.7984H120.244L113.739 59.6621L107.3 66.7984H99.4249Z",
    fill: "#1D71B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5889 16H91.8473L96.1527 25.777V16H111.287L113.897 23.3249L116.515 16H128.071V44.5712H67L79.5889 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9112 19.1045L72.0182 41.3804H78.8033L80.6687 36.9193H90.7814L92.6468 41.3804H99.5997L89.7483 19.1045H81.9112ZM82.7608 31.9201L85.7268 24.8288L88.691 31.9201H82.7608Z",
    fill: "#1D71B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.508 41.3767V19.1008L109.044 19.1336L113.952 32.8283L118.892 19.1008H128.071V41.3767L122.165 41.4286V26.1263L116.589 41.3767H111.197L105.506 26.0744V41.3767H99.508Z",
    fill: "#1D71B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_4439"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H116C122.627 0 128 5.37258 128 12V74C128 80.6274 122.627 86 116 86H12C5.37258 86 0 80.6274 0 74V12Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAmericanExpress);
export default __webpack_public_path__ + "static/media/billing-american-express.7b8e095dbf93f2b816adbf443dca6ee7.svg";
export { ForwardRef as ReactComponent };